export default function () {
  return {
    data() {
      return {
        themeObj: {},
      }
    },
    methods: {
      setDefaultConfig(defaultPropsArr) {
        Object.keys(defaultPropsArr).forEach(key => {
          if(!this[key]) {      // 没有默认值，引用default中的值
            this.$set(this.themeObj, key, defaultPropsArr[key])
          } else {              // 有默认值，则使用默认值
            this.$set(this.themeObj, key, this[key])
          }
        })
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/k-element/common/k-theme.js